exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-31830aa8] .el-table thead.is-group th{background-color:#f7fbff;border-color:#fff}.el-icon-d-arrow-right[data-v-31830aa8]{margin:0 12px}[data-v-31830aa8] .el-table td{border:none}[data-v-31830aa8] .el-table{border:none}.red[data-v-31830aa8]{cursor:pointer;color:red}\n", ""]);

// exports
